export default "__VITE_ASSET__DLobSO$d__"